import type { Purchase } from "../api-client/models/purchase";
import type { UserClass } from "../api-client";
import { useUserQuery } from "./useUserQuery";

// Main useUser hook - now uses TanStack Query
export const useUser = (): UserClass => {
  const { user } = useUserQuery();
  return user;
};

// Export mutateUser from useUserQuery for backward compatibility
export { mutateUser } from "./useUserQuery";

// Backward compatible myMutate - invalidates queries by endpoint name
export const myMutate = async (endpointName: string) => {
  const { queryClient, queryKeyIncludes } = await import("../lib/queryClient");

  // Convert old endpoint names to query key patterns
  const keyPatterns = [
    endpointName.replace("bound ", ""),
    endpointName,
    "bound " + endpointName,
  ];

  return Promise.all(
    keyPatterns.map((pattern) =>
      queryClient.invalidateQueries({
        predicate: queryKeyIncludes(pattern, "/all/notifs"),
      })
    )
  );
};

export const mutatePurchases = async () => {
  const { queryClient, queryKeyIncludes } = await import("../lib/queryClient");
  await queryClient.invalidateQueries({
    predicate: queryKeyIncludes("/all/purchases", "/all/notifs"),
  });
};

export const mutatePurchase = async (
  _key: string,
  _result: Purchase | void,
) => {
  await mutatePurchases();
};

export const mutateDeletePurchase = async (
  _key: string,
  _result: Purchase | void,
) => {
  await mutatePurchases();
};
